import {spellKey} from "./affinityRowMerge";

const text = (value) => (value === null || value === undefined ? '' : String(value).trim().toLowerCase());

// One profile spelled with or without the scheme, www or a trailing slash.
const linkedinKey = (url) => text(url).replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/+$/, '');

const SCALARS = {
    name: text,
    crd_id: text,
    linkedin_url: linkedinKey,
    gender: text,
};

const ROWS = {
    companies: (row) => spellKey(row, 'display_id'),
    universities: (row) => spellKey(row, 'university_id'),
    achievements: (row) => String(row.id),
};

// What accepting the match changes on the form, read off the form before and after the import
// rather than re-derived from the payload, so it cannot drift from what the import really does.
export const importedChanges = (formCard, importedCard) => {
    if (!formCard || !importedCard) return null;

    const scalars = {};
    Object.entries(SCALARS).forEach(([field, key]) => {
        const after = key(importedCard[field]);
        if (after && after !== key(formCard[field])) scalars[field] = after;
    });

    const rows = {};
    Object.entries(ROWS).forEach(([field, key]) => {
        const before = new Set((formCard[field] || []).map(key));
        rows[field] = new Set((importedCard[field] || []).map(key).filter((rowKey) => !before.has(rowKey)));
    });

    return {
        scalars,
        rows,
        photo: !!importedCard.photo_url && importedCard.photo_url !== formCard.photo_url,
    };
};

// True when this record's value is one the import brings into the form.
export const isImportedScalar = (changes, field, value) => {
    const imported = changes?.scalars?.[field];
    return !!imported && imported === SCALARS[field](value);
};

export const isImportedRow = (changes, field, row) => !!changes?.rows?.[field]?.has(ROWS[field](row));

// The form's own rows, in the card shape; rows marked for removal are not on the contact anymore.
export const liveRows = (rows) => (rows || []).filter((row) => !row._destroy);
